import PropTypes from 'prop-types';
import Icon from 'Components/Atoms/Icon/Icon';
import IconButton from 'Components/Atoms/IconButton/IconButton';
import { RHFInput, RHFInputCurrency } from 'Components/Organisms/HookForm';
import { getCurrencySymbol } from 'Utils/formatters';
import useLocale from 'Hooks/useLocale';
import { useTranslation } from 'react-i18next';
import { cn } from 'Utils/cn';

export default function TransactionSplitEditorDrawerSlice(props) {
    const { className, name, currency, onDelete, autoFocus } = props;

    const { t } = useTranslation('transactions');
    const locale = useLocale();
    const currencySymbol = getCurrencySymbol(locale, currency);

    return (
        <div className={cn('flex items-center py-2 w-full', className)}>
            <div className="grid items-start gap-2 grid-cols-[1fr_120px] grow">
                <RHFInput name={`${name}.description`} placeholder={t('concept')} autoFocus={autoFocus} />
                <RHFInputCurrency name={`${name}.amount`} step="0.01" placeholder="0.00" prefix={currencySymbol} />
            </div>
            <div className="h-11 flex items-center">
                <IconButton
                    variant="ghost"
                    icon={<Icon name="trash" size={16} color="currentColor" />}
                    onClick={onDelete}
                />
            </div>
        </div>
    );
}

TransactionSplitEditorDrawerSlice.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    currency: PropTypes.string,
    autoFocus: PropTypes.bool,
};
